import React, { Component } from 'react';
import { Navbar, Nav, NavItem, NavDropdown, MenuItem } from 'react-bootstrap/lib';
import { LinkContainer } from 'react-router-bootstrap';

class AdminMenu extends Component {
    render() {
        return (
            <Navbar fluid bsStyle="default" className="AdminMenu">
                <Navbar.Header className="">
                    <Navbar.Brand className="visible-xs">
                        Webmanager
                    </Navbar.Brand>
                    <Navbar.Toggle />
                </Navbar.Header>
                <Navbar.Collapse>
                    <Nav>
                        <LinkContainer exact to="/admin">
                            <NavItem eventKey={2}>
                                Webmanager
                            </NavItem>
                        </LinkContainer>
                        <LinkContainer exact to="/admin/leden">
                            <NavItem eventKey={2}>
                                Leden
                            </NavItem>
                        </LinkContainer>
                        <LinkContainer exact to="/admin/bedrijven">
                            <NavItem eventKey={3}>
                                Bedrijven
                            </NavItem>
                        </LinkContainer>
                        <NavDropdown eventKey={4} title="Kennis" id="kennis-dropdown">
                            <LinkContainer exact to="/admin/kennis">
                                <MenuItem eventKey={4.1}>Overzicht</MenuItem>
                            </LinkContainer>
                            <LinkContainer exact to="/admin/kennis/opleiding">
                                <MenuItem eventKey={4.3}>Opleiding overzicht</MenuItem>
                            </LinkContainer>
                            <LinkContainer exact to="/admin/kennis/cursus">
                                <MenuItem eventKey={4.4}>Cursus overzicht</MenuItem>
                            </LinkContainer>
                            <LinkContainer exact to="/admin/kennis/docentschap">
                                <MenuItem eventKey={4.5}>Docentschap overzicht</MenuItem>
                            </LinkContainer>
                            <LinkContainer exact to="/admin/kennis/publicaties">
                                <MenuItem eventKey={4.6}>Publicaties overzicht</MenuItem>
                            </LinkContainer>
                            <LinkContainer exact to="/admin/kennis/lidmaatschap">
                                <MenuItem eventKey={4.7}>Lidmaatschap overzicht</MenuItem>
                            </LinkContainer>
                            <LinkContainer exact to="/admin/kennis/voordracht">
                                <MenuItem eventKey={4.8}>Voordracht overzicht</MenuItem>
                            </LinkContainer>
                            <LinkContainer exact to="/admin/kennis/bijeenkomst">
                                <MenuItem eventKey={4.9}>Bijeenkomst overzicht</MenuItem>
                            </LinkContainer>
                            <LinkContainer exact to="/admin/kennis/incompany">
                                <MenuItem eventKey={4.10}>Incompany overzicht</MenuItem>
                            </LinkContainer>
                        </NavDropdown>
                        {/* <LinkContainer exact to="/admin/groepen">
                            <NavItem eventKey={5}>
                                Groepen
                            </NavItem>
                        </LinkContainer> */}
                        <LinkContainer exact to="/admin/mededelingen">
                            <NavItem eventKey={6}>
                                Mededelingen
                            </NavItem>
                        </LinkContainer>
                        {/* <LinkContainer exact to="/admin/roo2">
                            <NavItem eventKey={7}>
                                RO + O2
                            </NavItem>
                        </LinkContainer> */}
                        <LinkContainer exact to="/admin/accounts">
                            <NavItem eventKey={8}>
                                Accounts
                            </NavItem>
                        </LinkContainer>
                        {/* <LinkContainer exact to="/admin/registraties">
                            <NavItem eventKey={9}>
                                Registraties
                            </NavItem>
                        </LinkContainer> */}
                        <LinkContainer exact to="/admin/content">
                            <NavItem eventKey={10}>
                                Content
                            </NavItem>
                        </LinkContainer>
                        {/* <LinkContainer exact to="/admin/logs">
                            <NavItem eventKey={11}>
                                Logs
                            </NavItem>
                        </LinkContainer> */}
                    </Nav>
                </Navbar.Collapse>
            </Navbar>
        );
    }
}

export default AdminMenu;


// WEBPACK FOOTER //
// ./src/components/Admin/Modules/AdminMenu.js